export const LANDING_DEST = {
  ACTIVE_TICKET: 'active-ticket',
  LOAD_ASSIGNMENTS: 'load-assignments',
  TICKET_LIST: 'ticket-list',
};

/**
 * Flag-on entity root destination. Invalid vehicle / driver mismatch stay on
 * load-assignments so that page can show its existing error copy. A valid
 * vehicle with no displayable (unticketed, not CANCELLED) rows goes to ticket-list.
 */
export const resolveLandingDestination = ({
  hasPendingTicket,
  savedVehicleId,
  vehicleFound,
  matchesLoggedInDriver,
  displayableAssignmentCount,
} = {}) => {
  if (hasPendingTicket) {
    return LANDING_DEST?.ACTIVE_TICKET;
  }

  if (!savedVehicleId) {
    return LANDING_DEST?.LOAD_ASSIGNMENTS;
  }

  if (vehicleFound !== true || matchesLoggedInDriver !== true) {
    return LANDING_DEST?.LOAD_ASSIGNMENTS;
  }

  if ((displayableAssignmentCount ?? 0) > 0) {
    return LANDING_DEST?.LOAD_ASSIGNMENTS;
  }

  return LANDING_DEST?.TICKET_LIST;
};
